import { createStyles, makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() =>
  createStyles({
    button: {
      margin: "20px 0",
    },
  })
);
